import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=1b00aad2&"
import script from "./FormEditor.vue?vue&type=script&lang=js&"
export * from "./FormEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormEditor.vue?vue&type=style&index=0&id=1b00aad2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports